import { I18n } from '@calendly/i18n'

import { DAY_KEYS } from './constants'


export const getDefaultDays = (rules) => DAY_KEYS.reduce((defaultDays, dayKey) => {
  const day = rules.find((r) => r.wday === dayKey)

  return {
    ...defaultDays,
    [dayKey]: day?.intervals ? day.intervals.map((interval) => ({ ...interval })) : []
  }
}, {})

const formatIntervals = (intervals) => {
  const sortedIntervals = intervals.sort((a, b) => parseFloat(a.from) - parseFloat(b.from))
  return sortedIntervals.map((interval) => ({
    from: interval.from,
    to: interval.to,
  }))
}

export const encodeAvailabilityRule = (availabilityRule, { timezone, days, activeDates }) => ({
  ...availabilityRule,
  timezone,
  rules: Object.keys(days).map((wday) => ({
    wday,
    type: 'wday',
    intervals: formatIntervals(days[wday]),
  })).concat(activeDates),
})

export const infoForLocation = (locationKinds) => {
  if (locationKinds.length === 1) {
    return I18n.t(`publisher.event_types.location.${locationKinds[0]}.label`)
  }
  return I18n.t('publisher.event_type_editor.summary.multiple_options')
}
